import {UI} from "../../../../stem-core/src/ui/UIBase";

import {Messages} from "../../../Messages";
import {PoweredByBlink} from "../../PoweredByBlink";
import {MerchantButton} from "../../../common/MerchantButton";
import {DONATE_PAGE_URLS} from "../../PanelConstants";
import {styleRule, styleRuleInherit} from "../../../../stem-core/src/decorators/Style";
import {
    LoginWithEmailCode,
    LoginWithEmailCodeStyle
} from "../../../website/unauthenticated/slides/LoginWithEmailCodeForm";
import {registerStyle} from "../../../../stem-core/src/ui/style/Theme";
import {StepDescription} from "../StepDescription";
import {donatePageOnAuthenticate} from "../auth/AuthenticationPanel";


class DonateHomeLoginWithEmailCodeStyle extends LoginWithEmailCodeStyle {
    @styleRuleInherit
    component = {
        " button": this.themeProps.DONATE_PAGE_BUTTON,
        " input": {
            borderColor: this.themeProps.DONATE_PAGE_SWITCHER_BORDER_COLOR,
            background: "transparent",
        },
        " input:focus": {
            borderColor: this.themeProps.DONATE_PAGE_INPUT_FOCUSED_BORDER_COLOR,
            boxShadow: this.themeProps.DONATE_PAGE_INPUT_FOCUSED_SHADOW,
        }
    };

    @styleRule
    title = this.themeProps.PANEL_TITLE;

    @styleRuleInherit
    resendCode = {
        color: this.themeProps.MERCHANT_LINK,
        fontSize: this.themeProps.MERCHANT_FONT_SIZE_LARGE,
        fontWeight: this.themeProps.MERCHANT_FONT_WEIGHT_REGULAR,
        margin: "20px auto",
        ">:first-child": {
            ":hover": {
                textDecoration: "none",
            },
        },
    };
}

@registerStyle(DonateHomeLoginWithEmailCodeStyle)
class DonateHomeLoginWithEmailCode extends LoginWithEmailCode {
    getBeforeInput() {
        return [
            <div className={this.styleSheet.title}>{Messages.authEmailConfirmationTitle}</div>,
            super.getBeforeInput(),
        ];
    }

    getAfterInput() {
        return [super.getAfterInput() , <PoweredByBlink/>];
    }
}

export class AuthCodeConfirmationPanel extends UI.Element {
    render() {
        return [
            <StepDescription backFunction={() => this.options.changeURL(DONATE_PAGE_URLS.donate, true)}
                             currentStep={2} stepDescription={Messages.authenticate}/>,
            <DonateHomeLoginWithEmailCode ButtonClass={MerchantButton}
                                      onWrongEmailButtonClick={() => this.options.changeURL(DONATE_PAGE_URLS.auth)}/>
         ];
    }

    onMount() {
        super.onMount();
        donatePageOnAuthenticate(this);
    }
}
